import { Field, useFormikContext } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DeleteIcon from "../../../assets/icons/delete-icon";
import { url } from "../../../redux/config";
import "../../forms/form.css";
import SearchAddFeild from "../../forms/search-add-field";
import errorToast from "../../helper-components/error-toast";
import { api } from "../../../redux/apis/api";
import {
  purchaseProductDetailsAction,
  purchaseProductListAction,
} from "../../../redux/actions/purchase-action";
import successToast from "../../helper-components/success-toast";
import { truncateString } from "../../helper-components/helper-function";
import SelectField from "../../forms/select-field";
import AddButton from "../../buttons/button";

const PurchaseOrderItemsSec = ({
  initialData,
  disabled = false,
  searchRef,
  type = "",
  prefixName = "pot",
  heading = [],
}) => {
  const inputRefs = useRef(null);
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const options =
        data?.data === null
          ? []
          : data.data
              .map((item) => ({
                value: item.item_id,
                label: item[field],
              }))
              .filter(
                (option) =>
                  !values?.data?.some((item) => item?.item_id === option.value)
              );
      setLocalData(data.data);
      callback(options);
    };
    const onError = (data) => {};
    if (inputValue?.length > 0) {
      dispatch(
        purchaseProductListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const removeRow = (rowIndex, type = "") => {
    let updatedData = [...values.data];

    if (type === "all") {
      updatedData =
        updatedData.length > 0 ? [updatedData[updatedData.length - 1]] : [];
    } else {
      updatedData.splice(rowIndex, 1);
    }
    setFieldValue("data", updatedData);

    const raw_total_amount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_total_amount) || 0);
    }, 0);

    const total_tax = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_tax_amount) || 0);
    }, 0);

    const total_discount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_discount_amount) || 0);
    }, 0);

    // Subtotal = Total - Tax - Discount
    const sub_total = (raw_total_amount - total_tax - total_discount).toFixed(
      2
    );

    const total_amount = Math.round(raw_total_amount).toFixed(2);
    const round_off_value = (
      Math.round(raw_total_amount) - raw_total_amount
    ).toFixed(2);

    // Set all values to form
    setFieldValue(`${prefixName}_sub_total`, sub_total);
    setFieldValue(`${prefixName}_total_gst`, total_tax);
    setFieldValue(`${prefixName}_total_discount`, total_discount);
    setFieldValue(`${prefixName}_total_amount`, total_amount);
    setFieldValue(`${prefixName}_round_off_value`, round_off_value);
  };

  //ON QUANTITY CHANGE
  const handleQuantityDiscChange = async (
    qty,
    rowIndex,
    item_unit_price,
    discount
  ) => {
    const updatedData = values.data.map((row, index) =>
      index === rowIndex
        ? {
            ...row,
            quantity: parseFloat(qty),
            item_unit_price: item_unit_price,
          }
        : row
    );
    setFieldValue("data", updatedData);
    const totalAmount = parseFloat(item_unit_price) * parseFloat(qty ?? 1);

    try {
      const response = await api.get(
        `${url}/discount/get?totalAmountOfItem=${totalAmount}&item_quantity=${
          qty ?? ""
        }&item_discount_percentage=${discount}&item_id=${
          values?.data?.[rowIndex]?.item_id
        }&cmr_phone_number=${values?.cmr_phone_number}`,
        JSON.stringify(totalAmount)
      );

      const tax =
        response.data?.code === 200 ? response.data.data.item_tax_amount : 0;
      const isInter = values?.is_inter_state === true;
      const parsedTax = parseFloat(tax);
      const updatedDataRow = {
        ...updatedData[rowIndex],
        item_gst:
          response.data?.code === 200
            ? response.data.data.item_total_tax_percentage
            : 0,
        item_total_tax_percentage:
          response.data.data.item_total_tax_percentage ?? 0, //new
        item_discount_amount: response.data.data.item_discount_amount ?? 0, //new

        item_discount_percentage:
          response.data.data.item_discount_percentage ?? 0, //new

        item_sgst: isInter ? 0 : parseFloat((parsedTax / 2).toFixed(2)),
        item_cgst: isInter ? 0 : parseFloat((parsedTax / 2).toFixed(2)),
        item_igst: isInter ? parsedTax : 0,
        item_total_amount: response.data.data.item_total_amount ?? 0, //new

        // item_total_amount:
        //   totalAmount -
        //   parseFloat(response?.data?.data?.item_discount_amount || 0) +
        //   parseFloat(response?.data?.data?.item_tax_amount || 0),
        item_tax_amount: parseFloat(tax || 0),
      };
      updatedData[rowIndex] = updatedDataRow;

      setFieldValue("data", [...updatedData]);

      const raw_total_amount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.item_total_amount) || 0);
      }, 0);

      const total_tax = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.item_tax_amount) || 0);
      }, 0);

      const total_discount = updatedData.reduce((sum, item) => {
        return sum + (parseFloat(item.item_discount_amount) || 0);
      }, 0);

      // Subtotal = Total - Tax - Discount
      const sub_total = (raw_total_amount - total_tax - total_discount).toFixed(
        2
      );

      const total_amount = Math.round(raw_total_amount).toFixed(2);
      const round_off_value = (
        Math.round(raw_total_amount) - raw_total_amount
      ).toFixed(2);

      // Set all values to form
      setFieldValue(`${prefixName}_sub_total`, sub_total);
      setFieldValue(`${prefixName}_total_gst`, total_tax);
      setFieldValue(`${prefixName}_total_discount`, total_discount);
      setFieldValue(`${prefixName}_total_amount`, total_amount);
      setFieldValue(`${prefixName}_round_off_value`, round_off_value);
    } catch (error) {}
  };

  const hasDuplicateItemId = (itemId, currentIndex) => {
    const itemIdsExceptCurrent = values.data
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.item_id);

    return itemIdsExceptCurrent.includes(itemId);
  };

  const onSuccessDetails = (data, rowIndex, filteredData) => {
    const oldData = [...values?.data];
    oldData.pop();
    const updatedData = {
      ...filteredData,
      total_sellable_quantity: data?.data?.total_sellable_quantity,
      uom_dropdown: data?.data?.uom_dropdown
        ? data?.data?.uom_dropdown?.map((uom) => ({
            item_uom_id: uom?.item_id,
            label: uom?.alt_uom,
            value: uom?.alt_uom,
            qty: uom?.base_quantity,
          }))
        : [],
    };

    setFieldValue("data", [...oldData, updatedData, initialData]);
    inputRefs.current?.focus();
  };

  const onErrorDetails = (data) => {};

  return (
    <>
      <div
        style={{
          maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
          height: "auto", // Let it grow naturally to fit its content
        }}
        className={`border border-[var(--create-table-main-border)] border-1 border-radius p-3`}
      >
        <div
          style={{
            maxHeight: `100%`,
            minHeight: `5rem`,
          }}
          className={`tab-container border-radius ${
            disabled ? "mt-[1rem]" : ""
          }`}
        >
          <table className="w-full border-collapse mt-0">
            <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
              <tr className="relative h-[50px]">
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => (
                    <th
                      style={{ minWidth: `${heading?.minWidth}px` }}
                      key={index}
                      className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                    >
                      {heading?.value === "clear_all" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                            width: "100%", // Ensure the div takes full width of the th
                          }}
                        >
                          {!disabled && (
                            <AddButton
                              type="button"
                              onclkFn={() => {
                                if (values?.data?.length > 0) {
                                  removeRow(0, "all");
                                }
                              }}
                              prefixIcon={false}
                              text={"Clear All"}
                              className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                            />
                          )}
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 w-full"
                          style={{
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                          }}
                        >
                          {heading?.label}
                        </div>
                      )}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="h-full">
              {console.log("values.data", values.data?.[0])}
              {values?.data?.map((rowData, rowIndex) => (
                <tr
                  className={`  bg-[var(--create-table-row-bg)]   h-[50px] `}
                  key={rowIndex}
                >
                  {heading
                    ?.filter((heading) => heading?.enabled !== false)
                    ?.map((heading, index) => {
                      return (
                        <td
                          style={{
                            minWidth: `${heading?.minWidth}px`,
                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                          }}
                          key={index}
                          className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                        >
                          {heading.value === "item_name" ||
                          heading.value === "item_code" ||
                          heading.value === "item_generic_name" ||
                          heading.value === "molecule_name" ? (
                            <div title={rowData[heading.value]}>
                              <SearchAddFeild
                                searchRef={
                                  heading.value === "item_name" ? searchRef : {}
                                }
                                isDisabled={
                                  values?.data?.length - 1 !== rowIndex ||
                                  disabled
                                    ? true
                                    : false
                                }
                                errorClass="hidden"
                                isRequired={false}
                                value={{
                                  label: rowData[heading.value],
                                  value: "",
                                }}
                                name={`data[${rowIndex}].${heading.value}`}
                                field={heading.value}
                                isLabelReq={false}
                                defaultSelectClass=""
                                placeholder=""
                                fetchData={fetchData}
                                onChange={async (selectedOption) => {
                                  const filteredData = localData
                                    ?.filter(
                                      (item) =>
                                        item?.item_id === selectedOption?.value
                                    )
                                    .map((item) => ({
                                      item_pur_min_uom_quantity:
                                        item?.item_pur_min_uom_quantity ?? "",

                                      sl_no: 1,
                                      item_name: item.item_name,
                                      item_generic_name:
                                        item?.item_generic_name,
                                      molecule_name: item?.molecule_name,
                                      item_code: item.item_code,
                                      item_manufacturer_name:
                                        item?.item_manufacturer_name,
                                      item_return_availability:
                                        item?.item_sales_returns ? true : false,
                                      item_uom:
                                        item.item_pur_purchasing_uom_name ===
                                        null
                                          ? ""
                                          : item.item_pur_purchasing_uom_name,
                                      total_sellable_quantity: 0,
                                      quantity: "",
                                      item_unit_price: item?.item_unit_price,
                                      item_min_max: "",
                                      ...(type === "sales"
                                        ? { sales_order_qty: 0 }
                                        : {}),
                                      item_total_amount: 0,

                                      item_id: item?.item_id,
                                      item_baby_box_packing:
                                        item?.item_baby_box_packing ?? "", //new
                                      mrp: item?.mrp ?? "0", //new
                                      item_purchase_return:
                                        item?.item_purchase_return
                                          ? item?.item_purchase_return === true
                                            ? "N"
                                            : "Y"
                                          : "Y", //new
                                      item_batch_total_base_purchase_rate:
                                        item?.item_batch_total_base_purchase_rate,
                                      // item_discount_percentage:
                                      //   item?.item_discount_percentage ?? 0, //new
                                      // item_discount_amount:
                                      //   item?.item_discount_amount ?? 0, //new
                                      // item_total_tax_percentage:
                                      //   item?.item_total_tax_percentage ?? 0, //new

                                      item_uom_id:
                                        item?.item_pur_purchasing_uom_name_id ??
                                        "",
                                      item_price_wiithout_tax: 0,
                                      uom_dropdown: [],
                                      // uom_dropdown: item?.uom_dropdown
                                      //   ? item?.uom_dropdown.map((uom) => ({
                                      //       item_uom_id: uom?.item_id,
                                      //       label: uom?.alt_uom,
                                      //       value: uom?.alt_uom,
                                      //     }))
                                      //   : [],
                                      item_manufacturer_id:
                                        item?.item_manufacturer_id,
                                      item_minimun_purchasing:
                                        item?.item_minimun_purchasing ?? 0,
                                      item_maximum_purchasing:
                                        item?.item_maximum_purchasing ?? 0,
                                      item_hsn: item.item_hsn,
                                      uom_group_id: item?.item_uom || "",
                                    }));

                                  dispatch(
                                    purchaseProductDetailsAction(
                                      {
                                        item_id: filteredData?.[0]?.item_id,
                                        item_uom:
                                          filteredData?.[0]?.uom_group_id,
                                      },
                                      (data) => {
                                        onSuccessDetails(
                                          data,
                                          rowIndex,
                                          ...filteredData
                                        );
                                      },
                                      onErrorDetails
                                    )
                                  );

                                  // const oldData = [...values?.data];
                                  // oldData.pop();

                                  // setFieldValue("data", [
                                  //   ...oldData,
                                  //   ...filteredData,
                                  //   initialData,
                                  // ]);
                                  // inputRefs.current?.focus();
                                }}
                              />
                            </div>
                          ) : heading.value === "item_request_quantity" ? (
                            <div className="flex">
                              <Field name={`data[${rowIndex}].quantity`}>
                                {({ field }) => (
                                  <input
                                    ref={inputRefs}
                                    min={0}
                                    {...field}
                                    type="number"
                                    step="1"
                                    placeholder=""
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled
                                    }
                                    // onKeyDown={(event) => {
                                    //   if (
                                    //     event.key === "-" ||
                                    //     event.key === "e" ||
                                    //     event.key === "."
                                    //   ) {
                                    //     event.preventDefault();
                                    //   }
                                    //   if (
                                    //     event.key === "Tab" ||
                                    //     event.key === "Enter"
                                    //   ) {
                                    //     handleQuantityDiscChange(event, rowIndex);
                                    //     setFieldValue(
                                    //       `data[${rowIndex}].quantity`,
                                    //       event.target.value
                                    //     );
                                    //   }
                                    // }}

                                    onKeyDown={(event) => {
                                      if (
                                        event.target.value >
                                        rowData.item_maximum_purchasing
                                      )
                                        if (
                                          event.key === "-" ||
                                          event.key === "e" ||
                                          event.key === "."
                                        ) {
                                          event.preventDefault();
                                        }
                                      // if (
                                      //   event.key === "Tab" ||
                                      //   event.key === "Enter"
                                      // ) {
                                      //   event.preventDefault();

                                      //   if (searchRef && searchRef.current) {
                                      //     setTimeout(() => {
                                      //       searchRef.current.focus();
                                      //     }, 0);
                                      //   }
                                      // }
                                    }}
                                    onBlur={(event) => {
                                      if (
                                        Number(
                                          values.data?.[rowIndex]
                                            ?.item_maximum_purchasing
                                        ) !== 0 &&
                                        values?.data?.[rowIndex]
                                          ?.selected_uom_qty *
                                          event.target.value >
                                          values.data?.[rowIndex]
                                            ?.item_maximum_purchasing
                                      ) {
                                        errorToast(
                                          `Maximum quantity should be ${values.data?.[rowIndex]?.item_maximum_purchasing}`
                                        );
                                      }

                                      if (
                                        values?.data?.[rowIndex]
                                          ?.selected_uom_qty &&
                                        values.data?.[rowIndex]
                                          ?.item_pur_min_uom_quantity
                                      ) {
                                        if (
                                          values?.data?.[rowIndex]
                                            ?.selected_uom_qty *
                                            event.target.value <
                                          values.data?.[rowIndex]
                                            ?.item_pur_min_uom_quantity
                                        ) {
                                          errorToast(
                                            `Mimimum quantity should be ${values.data?.[rowIndex]?.item_pur_min_uom_quantity}`
                                          );
                                        }
                                      }
                                      if (
                                        values?.data?.length - 1 === rowIndex ||
                                        hasDuplicateItemId(
                                          rowData.item_id,
                                          rowIndex
                                        ) ||
                                        disabled
                                      ) {
                                        event?.preventDefault();
                                      } else {
                                        handleQuantityDiscChange(
                                          event.target.value,
                                          rowIndex,
                                          rowData?.item_unit_price,
                                          rowData?.item_discount_percentage || 0
                                        );
                                      }
                                    }}
                                    // onChange={(event) => {
                                    //   if (
                                    //     values?.data?.length - 1 === rowIndex ||
                                    //     hasDuplicateItemId(
                                    //       rowData.item_id,
                                    //       rowIndex
                                    //     ) ||
                                    //     disabled
                                    //   ) {
                                    //     event?.preventDefault();
                                    //   } else {
                                    //     handleQuantityDiscChange(
                                    //       event,
                                    //       rowIndex,
                                    //       rowData?.item_unit_price
                                    //     );
                                    //   }
                                    // }}
                                    className="focus-within:ring-2 text-right min-w-[5rem]   px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading.value === "mrp" ? (
                            <div className="flex">
                              <Field name={`data[${rowIndex}].mrp`}>
                                {({ field }) => (
                                  <input
                                    {...field}
                                    type="number"
                                    min={0}
                                    step="0.01"
                                    placeholder=""
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(rowData.item_id, rowIndex) ||
                                      disabled
                                    }
                                    onKeyDown={(event) => {
                                      // Prevent invalid characters
                                      if (["e", "E", "-"].includes(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={(event) => {
                                      let mrpValue = event.target.value;

                                      if (mrpValue) {
                                        mrpValue = parseFloat(mrpValue).toFixed(2);
                                      }

                                      if (Number(mrpValue) < Number(rowData.item_unit_price)) {
                                        errorToast(`MRP should be greater than or equal to Tentative Price`);
                                      } else {
                                        setFieldValue(`data[${rowIndex}].mrp`, mrpValue);
                                      }
                                    }}
                                    onInput={(e) => {
                                      const value = e.target.value;
                                      if (value.includes(".")) {
                                        const [integer, decimal] = value.split(".");
                                        if (decimal.length > 2) {
                                          e.target.value = integer + "." + decimal.slice(0, 2);
                                        }
                                      }
                                    }}
                                    className="focus-within:ring-2 text-right min-w-[5rem] px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF] input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>

                            </div>
                          ) : heading.value === "item_discount_percentage" ? (
                            <div className="flex">
                              {console.log("rowData", rowData)}

                              <Field
                                name={`data[${rowIndex}].item_discount_percentage`}
                              >
                                {({ field }) => (
                                  <input
                                    min={0}
                                    // ref={inputRefs}
                                    {...field}
                                    type="number"
                                    step="1"
                                    placeholder=""
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled
                                    }
                                    onChange={(event) => {
                                      let val = parseFloat(event.target.value);

                                      // Auto-correct if value exceeds limits
                                      if (val < 0) {
                                        val = 0;
                                        event.target.value = 0;
                                      } else if (val > 100) {
                                        val = 100;
                                        event.target.value = 100;
                                      }

                                      setFieldValue(
                                        `data[${rowIndex}].item_discount_percentage`,
                                        val
                                      );
                                    }}
                                    // onKeyDown={(event) => {
                                    //   if (
                                    //     event.key === "-" ||
                                    //     event.key === "e" ||
                                    //     event.key === "."
                                    //   ) {
                                    //     event.preventDefault();
                                    //   }
                                    //   if (
                                    //     event.key === "Tab" ||
                                    //     event.key === "Enter"
                                    //   ) {
                                    //     handleQuantityDiscChange(event, rowIndex);
                                    //     setFieldValue(
                                    //       `data[${rowIndex}].quantity`,
                                    //       event.target.value
                                    //     );
                                    //   }
                                    // }}

                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "-" ||
                                        event.key === "e" ||
                                        event.key === "."
                                      ) {
                                        event.preventDefault();
                                      }
                                      // if (
                                      //   event.key === "Tab" ||
                                      //   event.key === "Enter"
                                      // ) {
                                      //   //event.preventDefault();

                                      //   if (searchRef && searchRef.current) {
                                      //     setTimeout(() => {
                                      //       searchRef.current.focus();
                                      //     }, 0);
                                      //   }
                                      // }
                                    }}
                                    onBlur={(event) => {
                                      handleQuantityDiscChange(
                                        rowData?.quantity,
                                        rowIndex,
                                        rowData?.item_unit_price,
                                        event.target.value
                                      );
                                    }}
                                    // onBlur={(event) => {
                                    //   let discountPercent = event.target.value;
                                    //   let discountAmount =
                                    //     (discountPercent *
                                    //       rowData?.item_unit_price *
                                    //       rowData?.quantity) /
                                    //     100;

                                    //   let totalAmount =
                                    //     parseFloat(rowData?.item_unit_price) *
                                    //       parseFloat(
                                    //         rowData?.item_request_quantity
                                    //       ) -
                                    //     parseFloat(discountAmount || 0) +
                                    //     parseFloat(
                                    //       rowData?.item_tax_amount || 0
                                    //     );
                                    // }}

                                    // onBlur={(event) => {
                                    //   if (
                                    //     values?.data?.[rowIndex]
                                    //       ?.selected_uom_qty &&
                                    //     values.data?.[rowIndex]
                                    //       ?.item_pur_min_uom_quantity
                                    //   ) {
                                    //     if (
                                    //       values?.data?.[rowIndex]
                                    //         ?.selected_uom_qty *
                                    //         event.target.value <
                                    //       values.data?.[rowIndex]
                                    //         ?.item_pur_min_uom_quantity
                                    //     ) {
                                    //       errorToast(
                                    //         `Mimimum quantity should be ${values.data?.[rowIndex]?.item_pur_min_uom_quantity}`
                                    //       );
                                    //     }
                                    //   }
                                    //   if (
                                    //     values?.data?.length - 1 === rowIndex ||
                                    //     hasDuplicateItemId(
                                    //       rowData.item_id,
                                    //       rowIndex
                                    //     ) ||
                                    //     disabled
                                    //   ) {
                                    //     event?.preventDefault();
                                    //   } else {
                                    //     handleQuantityDiscChange(
                                    //       event,
                                    //       rowIndex,
                                    //       rowData?.item_unit_price
                                    //     );
                                    //   }
                                    // }}
                                    // onChange={(event) => {
                                    //   if (
                                    //     values?.data?.length - 1 === rowIndex ||
                                    //     hasDuplicateItemId(
                                    //       rowData.item_id,
                                    //       rowIndex
                                    //     ) ||
                                    //     disabled
                                    //   ) {
                                    //     event?.preventDefault();
                                    //   } else {
                                    //     handleQuantityDiscChange(
                                    //       event,
                                    //       rowIndex,
                                    //       rowData?.item_unit_price
                                    //     );
                                    //   }
                                    // }}
                                    className="focus-within:ring-2 text-right min-w-[5rem]   px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading.value === "sl_no" ? (
                            <div>
                              <input
                                type="radio"
                                name="SerialNumberRadioGroup"
                                disabled={disabled}
                                value={rowIndex}
                                className="peer hidden"
                                id={rowIndex}
                              />
                              <label
                                htmlFor={rowIndex}
                                className="block cursor-pointer select-none rounded-xl p-3 text-center hover:bg-slate-100 peer-checked:bg-blue-100 peer-checked:font-bold peer-checked:outline-none peer-checked:ring-2 peer-checked:ring-blue-500"
                              >
                                {rowIndex + 1}
                              </label>
                            </div>
                          ) : heading.value === "item_manufacturer_name" ? (
                            <p title={rowData[heading.value]}>
                              {truncateString(
                                rowData[heading.value] ?? "",
                                100
                              )}
                            </p>
                          ) : heading.value === "item_uom" ? (
                            <div title={rowData.item_uom ?? ""}>
                              <SelectField
                                defaultInputClass="min-h-[42px] min-w-[8rem] rounded-[8px]  text-[var(--create-table-row-fg-color)] text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] input-field-no-spin-buttons placeholder:text-[var(--create-table-row-placeholder-color)] placeholder:text-[length:var(--create-table-batch-con-fs)] placeholder:font-[var(--create-table-row-font-weight)]  "
                                style={customStyles}
                                inputBorder=""
                                general_color={false}
                                handleSelected={(sel) => {
                                  setFieldValue(
                                    `data[${rowIndex}].item_uom_id`,
                                    sel?.item_uom_id
                                  );
                                  setFieldValue(
                                    `data[${rowIndex}].selected_uom_qty`,
                                    sel?.qty
                                  );
                                  console.log("====", sel);
                                }}
                                borderclass=""
                                defaultSelectClass="border-0"
                                selectClass="w-full"
                                defaultValue={
                                  values.data[rowIndex]?.item_uom
                                    ? {
                                        label:
                                          values.data[rowIndex]?.item_uom ?? "",
                                      }
                                    : null
                                }
                                isDisabled={disabled}
                                errMsgContainerClass="hidden"
                                id={`data[${rowIndex}].item_uom`}
                                isContainer={false}
                                options={values.data[rowIndex]?.uom_dropdown}
                                name={`data[${rowIndex}].item_uom`}
                                placeholder={"Select UOM"}
                              />
                            </div>
                          ) : heading?.value === "item_unit_price" ? (
                            <div>
                              <Field name={`data[${rowIndex}].item_unit_price`}>
                                {({ field }) => (
                                  <input
                                    autoFocus={false}
                                    min={0}
                                    {...field}
                                    type="number"
                                    step="any"
                                    placeholder=""
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled
                                    }
                                    onChange={(event) => {
                                      let val = Number(event.target.value);
                                      let mrp = Number(rowData.mrp);
                                      if (mrp > 0 && val > mrp) {
                                        val = mrp;
                                        errorToast(
                                          `Tentative Price should not be greater than MRP`
                                        );
                                      }

                                      setFieldValue(
                                        `data[${rowIndex}].item_unit_price`,
                                        val
                                      );
                                    }}
                                    onBlur={(event) => {
                                      let val = event.target.value;
                                      if (!val) {
                                        val = 0;
                                      }
                                      setFieldValue(
                                        `data[${rowIndex}].item_unit_price`,
                                        val
                                      );
                                      handleQuantityDiscChange(
                                        values?.data?.[rowIndex]?.quantity,
                                        rowIndex,
                                        val,
                                        values?.data?.[rowIndex]
                                          ?.item_discount_percentage || 0
                                      );
                                    }}
                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "-" ||
                                        event.key === "e"
                                      ) {
                                        event.preventDefault();
                                      }

                                      // Move to next field on Enter or Tab
                                      // if (
                                      //   event.key === "Enter" ||
                                      //   event.key === "Tab"
                                      // ) {
                                      //   //event.preventDefault(); // prevent default Enter/Tab behavior
                                      //   const nextInput =
                                      //     document.querySelector(
                                      //       `input[name="data[${
                                      //         rowIndex + 1
                                      //       }].item_unit_price"]`
                                      //     );
                                      //   if (nextInput) {
                                      //     nextInput.focus();
                                      //   }
                                      // }
                                    }}
                                    className="focus-within:ring-2 text-right min-w-[5rem]   px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading?.value === "item_return_availability" ? (
                            rowData[heading.value] ? (
                              "No"
                            ) : (
                              "Yes"
                            )
                          ) : heading?.value === "item_minimun_purchasing" ? (
                            <span>
                              {rowData?.item_minimun_purchasing ?? "-"} -{" "}
                              {rowData?.item_maximum_purchasing ?? ""}
                            </span>
                          ) : heading.value === "clear_all" ? (
                            <button
                              type="button"
                              onClick={() => {
                                removeRow(rowIndex, "");
                              }}
                              style={{
                                display: "flex",
                                justifyContent:
                                  heading?.alignment === "right"
                                    ? "flex-end"
                                    : heading?.alignment === "center"
                                    ? "center"
                                    : "flex-start",
                                width: "100%", // Take full width of the td
                              }}
                            >
                              {!disabled &&
                                rowIndex !== values?.data?.length - 1 && (
                                  <DeleteIcon className="cursor-pointer text-red-500" />
                                )}
                            </button>
                          ) : (
                            rowData[heading.value]
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderItemsSec;

const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    fontFamily: "Inter,sans-serif ",
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
    borderRadius: "10px",
    width: "100%",
    backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    height: "100%",
  }),
  option: (provided, state) => {
    const defaultBackgroundColor = "white"; // Default background color
    const focusedBackgroundColor = "#0000002E"; // Background color when focused
    const selectedBackgroundColor = "#e5ecffb2"; // Background color when selected

    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      // backgroundColor: state?.isSelected ? "red" : "red",
      backgroundColor: state.isSelected
        ? selectedBackgroundColor // Use selected background color
        : state.isFocused
        ? focusedBackgroundColor // Use focused background color
        : defaultBackgroundColor, // Use default background color

      fontSize: "14px",
      zIndex: "999",
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused
          ? focusedBackgroundColor
          : focusedBackgroundColor, // Keeps hover state consistent
      },
    };
  },
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--placeholder-color)",
      fontFamily: "Inter,sans-serif",
      // fontSize: "14px",
      fontWeight: "400",
      opacity: "1",
      // position: "absolute",
      // top: "30%",
      whiteSpace: "nowrap",
    };
  },
  multiValue: (base) => ({
    ...base,
    fontFamily: "Inter,sans-serif ",
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    ...(state.selectProps.menuIsOpen
      ? {
          transform: "rotate(180deg)",
        }
      : {}),
  }),
};
